export default __webpack_public_path__ + "00ef1f2fabfbfa5cd87adbaffbe3a2da.png";